<img
    src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png"
    [class]="'flag flag-' + flagCode.toLowerCase()"
    class="block"
    [style.width]="width + 'px'"
    [alt]="altText" />
